import * as React from "react";
import { Avatar } from "primereact/avatar";
import Tooltip from "@mui/material/Tooltip";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MailIcon from "@mui/icons-material/Mail";

import MenuIcon from "@mui/icons-material/Menu";
import { useState, useRef } from "react";
// import { Test } from "./pages/test/test";
import "primeicons/primeicons.css";
import { Toast } from "primereact/toast";
// import { Test } from "./pages/test/test";
import { Logout } from "./pages/logout/logoutPage/logout";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Logo from "./assets/logo.png";
import Navbar from "./component/Navbar";
import NavbarGauche from "./component/NavbarGauche";
import "./App.css";

import { Link, useLocation } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Login } from "./pages/login/loginPage/login";
import { Stockage } from "./pages/stockage/stockage";
import { StockageRetard } from "./pages/stockageRetard/stockageRetard";
import { Client } from "./pages/client/ClientPage/client";
import { Reglement } from "./pages/reglement/reglementPage/Reglement";
import { Users } from "./pages/users/usersPage/users";
import { Contrat } from "./pages/contrat/contratPage/contrat";

import Tasklist from "./pages/tasklist/tasklist";
import FicheListe from "./pages/fiche/fiche";
import FicheDemandeListe from "./pages/ficheDemande/ficheDem";

import { Dash } from "./pages/dashboard/dashboardPage/dash";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LocationStockage } from "./pages/location/locationPage/locationStockage";
import { ToastContainer } from "react-toastify";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useEffect } from "react";
import { Facture } from "./pages/facture/facturePage/facture";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import "./styles/NavbarGauche.css";
import { Modal } from "@mui/material";
import { TieredMenu } from 'primereact/tieredmenu';


import HistoriqueMailsDem from "./pages/ficheDemande/historiqueMailsDem";
import HistoriqueMailsStock from "./pages/fiche/historiqueMailsStock";


import ReactDOM from "react-dom";
import "primeflex/primeflex.css";

const drawerWidth = 240;
function App(props) {
  const isMobilePortrait = useMediaQuery("(max-width:1400px) ");

  const [nomPageActive, setNomPageActive] = useState("");
  const locationGauche = useLocation();
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const navigate = useNavigate();
  const menu = useRef(null);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  let items = [
    {
      label: "Locations",
      icon: "pi pi-box",
      command: () => {
        navigate("/location");
      },
    },
    {
      label: "Factures",
      icon: "pi pi-receipt",
      command: () => {
        navigate("/facture");
      },
    },
    {
      label: "Contrats",
      icon: "pi pi-pen-to-square",
      command: () => {
        navigate("/contrat");
      },
    },
    {
      label: "Paiements",
      icon: "pi pi-credit-card",
      command: () => {
        navigate("/reglementListe");
      },
    },
    {
      label: "Déconnexion",
      icon: "pi pi-power-off",
      command: () => {
        setdeconnect(true);
      },
    },
  ];
  if (localStorage.getItem("us") === "admin") {
    items.unshift({
      label: "Utilisateurs",
      icon: "pi pi-users",
      command: () => {
        navigate("/users");
      },
    });
  }

  const [deconnectHovered, setDeconnectHovered] = useState(false);

  const [deconnect, setdeconnect] = useState(false);

const handleAvatarClick = (event) => {
  event.stopPropagation();
  
  try {
    if (menu.current) {
      if (typeof menu.current.toggle === 'function') {
        menu.current.toggle(event);
      } else if (typeof menu.current.show === 'function') {
        menu.current.show(event);
      }
    }
  } catch (error) {
    console.error('Menu toggle error:', error);
  }
};

useEffect(() => {
  const handleClickOutside = (event) => {
    try {
      if (menu.current && 
          menu.current.hide && 
          typeof menu.current.hide === 'function') {
        const avatarElement = event.target.closest('.avatar-trigger');
        if (!avatarElement && menu.current && menu.current.element) {
          const menuElement = menu.current.element;
          if (menuElement && !menuElement.contains(event.target)) {
            menu.current.hide();
          }
        }
      }
    } catch (error) {
      console.error('Error hiding menu:', error);
    }
  };

  document.addEventListener('click', handleClickOutside);
  return () => document.removeEventListener('click', handleClickOutside);
}, []);



  const closeMenu = () => {
  if (menu.current && menu.current.hide) {
    menu.current.hide();
  }
};

  const drawer = (
    <div>
      <Divider />

      <div className="navbarGauche">
        <div
          className="flex align-items-center mb-5 px-2"
          onClick={() => {
            setNomPageActive("TABLEAU DE BORD");
          }}
        >
          <img
            src={Logo}
            alt="Logo"
            style={{
              marginLeft: "5%",
              width: "100px",
              display: "block",
            }}
          />
        </div>

        <div className="flex-grow-1">
          <Link
            to="/"
            className={locationGauche.pathname === "/" ? "activeLink" : "ty"}
            onClick={() => setNomPageActive("TABLEAU DE BORD")}
          >
            <i className="pi pi-chart-pie mr-2"></i>
             <span>Tableau de bord</span>
          </Link>

          <Link
            to="/stockage"
            className={
              locationGauche.pathname === "/stockage" ? "activeLink" : "ty"
            }
            onClick={() => setNomPageActive("PLAN DU SITE")}
          >
            <i className="pi pi-sitemap mr-2"></i>
            <span>Plan du site</span>
          </Link>

          <Link
            to="/client"
            className={
              locationGauche.pathname === "/client" ? "activeLink" : "ty"
            }
            onClick={() => setNomPageActive("CLIENTS")}
          >
            <i className="pi pi-users mr-2"></i> <span>Clients</span>
          </Link>

          <Link
            to="/tasklist"
            className={
              locationGauche.pathname === "/tasklist" ? "activeLink" : "ty"
            }
            onClick={() => setNomPageActive("Listes des tâches")}
          >
            <i
              className="pi pi-check-square mr-2"
            ></i>
            <span>Tâches</span>
          </Link>

          <Link
            to="/fiche"
            className={
              locationGauche.pathname === "/fiche" ? "activeLink" : "ty"
            }
            onClick={() => setNomPageActive("Fiches stock")}
          >
            <i className="pi pi-box mr-2"></i>
            <span>Fiches stock</span>
          </Link>

          <Link
            to="/ficheDem"
            className={
              locationGauche.pathname === "/ficheDem" ? "activeLink" : "ty"
            }
            onClick={() => setNomPageActive("Fiche dem")}
          >
            <i className="pi pi-truck mr-2"></i>
            <span>Fiches dem</span>
          </Link>
        </div>

      </div>

      <Divider />
    </div>
  );
  const toast = useRef(null);
  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      {" "}
      <Box sx={{ display: "flex" }}>
        <ToastContainer />
        <Toast ref={toast} />
        <CssBaseline />
        <AppBar
          position="fixed"
          elevation={0}
          sx={{
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            ml: { sm: `${drawerWidth}px` },
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <Toolbar
            style={{
              backgroundColor: "#AFD3E2",
              color: "#146C94",
              justifyContent: "space-between",
              gap: "20px",
            }}
          >
            <div style={{ display: "flex", float: "left", left: "0" }}>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ mr: 2, display: { sm: "none" } }}
              >
                <MenuIcon />
              </IconButton>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <div style={{ display: "flex", gap: "10px", alignItems: "end" }}>
                <a
                  href="https://suivi.zotdevis.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    backgroundColor: "#06b6d4",
                    color: "white",
                    border: "none",
                    borderRadius: "6px",
                    padding: "8px 12px",
                    cursor: "pointer",
                    fontWeight: "bold",
                    textDecoration: "none",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  SUIVI
                </a>

                <a
                  href="https://dem.zotdevis.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    backgroundColor: "#f1c40f",
                    color: "white",
                    border: "none",
                    borderRadius: "6px",
                    padding: "8px 12px",
                    cursor: "pointer",
                    fontWeight: "bold",
                    textDecoration: "none",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  DEM
                </a>
              </div>

              <div>
                <Tooltip title={localStorage.getItem("us")} arrow>
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={handleAvatarClick}
                  >
                    <Avatar
                      shape="circle"
                      style={{ backgroundColor: "#2196F3", color: "#ffffff" }}
                    >
                      {localStorage.getItem("us")?.charAt(0)}
                    </Avatar>
                  </span>
                </Tooltip>

                <TieredMenu
                  model={items}
                  popup
                  ref={menu}
                  className="custom-menu"
                  style={{ marginTop: "30px" }}
                />
              </div>

              <Modal
                open={deconnect}
                disableBackdropClick={true}
                aria-describedby="modal-modal-description"
              >
                <Logout onClose={() => setdeconnect(false)} />
              </Modal>
            </div>
          </Toolbar>
        </AppBar>
        <Box
          component="nav"
          sx={{
            width: { sm: drawerWidth },
            flexShrink: { sm: 0 },
          }}
          aria-label="mailbox folders"
        >
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
              },
            }}
          >
            {drawer}
          </Drawer>
          <Drawer
            variant="permanent"
            style={{ overflow: " hidden" }}
            sx={{
              display: { xs: "none", sm: "block" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: "auto",
                height: "auto",
              },
            }}
            open
          >
            {drawer}
          </Drawer>
        </Box>
        <Box
          component="main"
          sx={{
            flexGrow: 2,
            p: 3,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
          }}
        >
          <Toolbar />

          <Routes>
            <Route path="/login" element={<Login />} />
            {/* <Route path="/facture" element={<Facture />} /> */}
            <Route path="/" element={<Dash />} />
            {isMobilePortrait ? null : (
              <>
                <Route path="/stockage" element={<Stockage />} />
                <Route path="/stockageRetard" element={<StockageRetard />} />
                <Route path="/client" element={<Client />} />
              </>
            )}
            <Route path="/location" element={<LocationStockage />} />
            <Route path="/reglementListe" element={<Reglement />} />
            <Route path="/contrat" element={<Contrat />} />
            <Route path="/tasklist" element={<Tasklist />} />
            <Route path="/fiche" element={<FicheListe />} />

            <Route path="/ficheDem" element={<FicheDemandeListe />} />
            <Route path="/users" element={<Users />} />
            <Route path="/facture" element={<Facture />} />

            <Route path="/historiqueMailDem" element={<HistoriqueMailsDem />} />
            <Route
              path="/historiqueMailStock"
              element={<HistoriqueMailsStock />}
            />
          </Routes>
        </Box>
        {isMobilePortrait ? (
          <>
            <Box
              sx={{
                flexGrow: 1,
                p: 3,
                marginLeft: `-${drawerWidth}px`,
              }}
            >
              <Toolbar />
              <Routes>
                <Route path="/stockage" element={<Stockage />} />{" "}
              </Routes>
            </Box>
          </>
        ) : null}{" "}
        {isMobilePortrait ? (
          <>
            <Box
              sx={{
                flexGrow: 1,
                p: 3,
                marginLeft: `-95px`,
              }}
            >
              <Toolbar />
              <Routes>
                <Route path="/stockageRetard" element={<StockageRetard />} />{" "}
              </Routes>
            </Box>
          </>
        ) : null}{" "}
        {isMobilePortrait ? (
          <>
            <Box
              sx={{
                flexGrow: 1,
                p: 3,
                // marginLeft: `-${drawerWidth}px`,
              }}
              style={{ width: "90vw" }}
            >
              <Toolbar />
              <Routes>
                <Route path="/client" element={<Client />} />{" "}
              </Routes>
            </Box>
          </>
        ) : null}
      </Box>
    </LocalizationProvider>
  );
}

App.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * Remove this when copying and pasting into your project.
   */
  window: PropTypes.func,
};

export default App;
